import { useAtom } from '@xstate/store/react';

import {
	activatePendingContent,
	audioPlayerState,
	closeAudioPlayer,
	openAudioPlayer,
	setActiveFeature,
	setIsPaused,
	setIsPlaying,
	updatePlayerState,
} from '../state/AudioPlayerState';

export const useAudioPlayerStore = () => {
	const state = useAtom(audioPlayerState);

	return {
		// State
		isOpen: state.isOpen,
		isPlaying: state.isPlaying,
		isPaused: state.isPaused,
		activeContent: state.activeContent,
		activeFeature: state.activeFeature,
		pendingContent: state.pendingContent,

		// Actions
		openAudioPlayer,
		closeAudioPlayer,
		activatePendingContent,
		setIsPlaying,
		setIsPaused,
		updatePlayerState,
		setActiveFeature,
	};
};
